module.exports = {
      id: "lifestyle-usage",
      viewBox: "0 0 24.217 32.155",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#lifestyle",
      toString: function () {
        return this.url;
      }
    }